import { getAuth } from "firebase/auth";
import { LoaderFunctionArgs, redirect } from "react-router-dom";
import * as APITypes from "~/API";
import { apiClient } from "~/services/apiClient";

export const ServiceRequestTablePageLoader = async ({
  request,
  params,
}: LoaderFunctionArgs): Promise<ServiceRequestTablePageLoaderType | ReturnType<typeof redirect>> => {
  const auth = getAuth();
  const user = auth.currentUser;
  if (!user) return redirect("/signup");

  const response = await apiClient.loader<{
    serviceRequests: APITypes.ServiceRequest[];
  }>("service-request-table");

  const userInfo = {
    userID: user.uid ?? "",
    tenantID: (user as { tenantId?: string }).tenantId ?? "",
    tenantName: user.displayName ?? "",
  };

  if (!response.success || !response.data) {
    return {
      userID: userInfo.userID,
      user: userInfo,
      serviceRequests: [],
    };
  }

  return {
    userID: userInfo.userID,
    user: userInfo,
    serviceRequests: response.data.serviceRequests,
  };
};

export type ServiceRequestTablePageLoaderType = {
  //filteredList: FormattedMessageData[];
  userID: string;
  user: {
    userID: string;
    tenantID: string;
    tenantName: string;
  };
  serviceRequests: APITypes.ServiceRequest[];
};
